var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","min-height":"1000px","overflow":"hidden"}},[_c('iframe',{attrs:{"allowfullscreen":"true","src":_vm.link,"frameborder":"0","width":"100%","height":"968px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }